import React from "react";

const BackgroundVisuals = () => {
    return (
        <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden select-none" style={{ contain: "paint" }}>
            {/* Blob azul suave en esquina superior izquierda */}
            <div className="absolute w-[450px] h-[450px] bg-cyan-500/20 rounded-full blur-[100px] top-[-100px] left-[-100px] animate-float1 will-change-transform" />

            {/* Blob rosa/púrpura flotando abajo a la derecha */}
            <div className="absolute w-[350px] h-[350px] bg-purple-500/20 rounded-full blur-[90px] bottom-[10%] right-[5%] animate-float2 will-change-transform" />

            {/* Blob central sutil */}
            <div className="absolute w-[280px] h-[280px] bg-blue-600/15 rounded-full blur-[90px] top-[35%] right-[25%] animate-float3 will-change-transform" />
        </div>
    );
};

export default BackgroundVisuals;
